<div style="overflow-y: auto" mdbModal #datosEditarProveedor="mdb-modal" class="modal fade" id="basicExample"
  tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-fluid" style="max-width: 60%;" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">Agregar Proveedor {{ProveedorRut}} a cliente</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="datosEditarProveedor.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>

      <div class="modal-body">
        <!-- Nav Tabs -->
        <mdb-tabset #staticTabs [buttonClass]="'md-tabs tabs-4 text-uppercase'" [contentClass]="'pd-0'">
          <!--Panel 1: Datos Personales-->
          <mdb-tab heading="Datos personales">
            <div class="row">
              <div class="col-12">
                <!-- (onRutExiste)="datosAgregarPersonales.hide()" -->
                <app-clientes-form-datos-personales mode="ADD" [optionsTipoCliente]="optionsTipoCliente"
                  [optionsCanal]="optionsCanal" (onNombreChange)="onNombreDatosPersonalesChange($event)" bandEdit="2">
                </app-clientes-form-datos-personales>
              </div>
            </div>
          </mdb-tab>

          <!--Panel 2: Direcciones-->
          <mdb-tab heading="Direcciones">
            <div class="row">
              <div class="col-12">
                <form [formGroup]="formDatosDirecciones">
                  <div class="row" style="border-bottom: 1px solid #dee2e6">
                    <div class="col">
                      <h5 class="modal-title w-100 text-left" id="myModalLabel">
                        Datos de dirección
                      </h5>
                    </div>
                    <div class="col">
                      <div class="switch info-switch">
                        <label>
                          Inactivo
                          <input type="checkbox" formControlName="estadoDireccion" />
                          <span class="lever"></span> Activo
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <div class="md-form" style="margin-bottom: 0">
                        ID interno <strong>{{ direccionCliente }}</strong>
                      </div>
                    </div>
                    <div class="col">
                      <div class="md-form" style="margin-bottom: 0">
                        <strong></strong>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <div class="md-form" style="margin-bottom: 0">
                        <mdb-checkbox [checked]="true" formControlName="esCasaMatriz"><span style="font-size: 1rem">Casa
                            matriz</span></mdb-checkbox>
                      </div>
                      <div class="md-form">
                        <input value="" type="text" id="nombre3" class="form-control" placeholder="Nombre" required
                          formControlName="nombre" maxlength="100" #nombre3 />
                        <label for="nombre3">Nombre <app-required-field></app-required-field></label>
                        <div *ngIf="
                            formDatosDirecciones.get('nombre').invalid &&
                            (formDatosDirecciones.get('nombre').dirty ||
                              formDatosDirecciones.get('nombre').touched)
                          ">
                          <mdb-error *ngIf="
                              formDatosDirecciones.get('nombre').errors
                                .required
                            ">
                            Debe ingresar el nombre identificador de la
                            dirección
                          </mdb-error>
                          <mdb-error *ngIf="
                              formDatosDirecciones.get('nombre').errors
                                .minlength
                            ">
                            El nombre debe tener un mínimo de 5 caracteres
                          </mdb-error>
                        </div>
                      </div>

                      <div class="md-form">
                        <mdb-select label="Comuna" [options]="optionsDatosDireccionAgregarComuna" placeholder="Comuna"
                          [filterEnabled]="true" formControlName="comuna"></mdb-select>
                        <div *ngIf="
                                                  formDatosDirecciones.get('comuna').invalid &&
                                                  (formDatosDirecciones.get('comuna').dirty ||
                                                    formDatosDirecciones.get('comuna').touched)
                                                ">
                          <mdb-error *ngIf="
                                                    formDatosDirecciones.get('comuna').errors
                                                      .required
                                                  ">
                            La comuna es requerida
                          </mdb-error>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col">
                          <div class="md-form" [ngStyle]="{'display': ShowLongLat == false ? 'block' : 'none'}">
                            <input value="" type="text" id="direccionForm" name="direccionForm" class="form-control"
                              placeholder="Ingrese dirección o selecione de la lista" formControlName="direccion"
                              autocorrect="off" autocapitalize="off" autocomplete="off" spellcheck="off"
                              (keydown.enter)="$event.preventDefault()" #direccionForm />

                            <input type="hidden" formControlName="direccionFormateada">

                            <label for="direccion4">Dirección <app-required-field></app-required-field>
                            </label>

                          </div>

                          <div class="md-form" *ngIf="ShowLongLat === true">
                            <input value="" type="text" id="direccionForm" name="direccion" class="form-control"
                              placeholder="Ingrese dirección" formControlName="direccNueva">


                            <label for="direccion4">Dirección <app-required-field></app-required-field>
                            </label>
                          </div>

                        </div>
                      </div>


                      <div class="row">
                        <div class="col">
                          <mdb-checkbox [checked]="false" formControlName="showCoordenadas"
                            (change)="ShowCoordenadasLatLong($event)">
                            <span style="font-size: 1rem">Ingreso manual de coordenadas</span>
                          </mdb-checkbox>
                        </div>
                      </div>

                      <div class="md-form">
                        <agm-map [fitBounds]="true" [usePanning]="true" [latitude]="latitude" [longitude]="longitude"
                          [zoom]="zoom" id="mapa">
                          <agm-marker [agmFitBounds]="true" [latitude]="latitude" [longitude]="longitude"
                            [markerDraggable]="true" (dragEnd)="markerDragEnd($event)" id="marcadores"></agm-marker>
                        </agm-map>
                      </div>

                      <div class="row">

                        <div class="col">
                          <div class="md-form">
                            <input value="" type="text" id="latitud" class="form-control" placeholder="Latitud" required
                              #latitud formControlName="latitud" [readonly]="ShowLongLat === false" />
                            <label for="latitud">Latitud</label>
                            <div *ngIf="
                                formDatosDirecciones.get('latitud')
                                  .invalid &&
                                (formDatosDirecciones.get('latitud')
                                  .dirty ||
                                  formDatosDirecciones.get('latitud')
                                    .touched)
                              ">
                              <mdb-error *ngIf="
                                  formDatosDirecciones.get('latitud')
                                    .errors.required
                                ">
                                La latitud es requerida
                              </mdb-error>
                            </div>
                          </div>
                        </div>
                        <div class="col">
                          <div class="md-form">
                            <input value="" type="text" id="longitud" class="form-control" placeholder="Longitud"
                              required #longitud formControlName="longitud" [readonly]="ShowLongLat === false" />
                            <label for="longitud">Longitud</label>
                            <div *ngIf="
                                formDatosDirecciones.get('longitud')
                                  .invalid &&
                                (formDatosDirecciones.get('longitud')
                                  .dirty ||
                                  formDatosDirecciones.get('longitud')
                                    .touched)
                              ">
                              <mdb-error *ngIf="
                                  formDatosDirecciones.get('longitud')
                                    .errors.required
                                ">
                                La longitud es requerida
                              </mdb-error>
                            </div>
                          </div>
                        </div>
                        <div class="col">
                          <div class="md-form">
                            <input value="" type="number" id="secuencia" class="form-control"
                              formControlName="secuencia" />
                            <label for="secuencia">Secuencia</label>
                          </div>
                        </div>

                      </div>

                    </div>

                    <div class="col">
                      <div class="row mb-2" style="border-bottom: 1px solid #dee2e6">
                        <div class="col">
                          <h5 class="modal-title w-100 text-left" id="myModalLabel">
                            Datos dirección
                          </h5>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col">
                          <div class="md-form" style="margin-bottom: 0">
                            <mdb-checkbox [checked]="true" formControlName="usaDireccionDespacho"
                              (change)="manejadorDireccionDespacho(false)">
                              <span style="font-size: 1rem">Despachar a misma dirección</span>
                            </mdb-checkbox>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-6">
                          <div class="md-form">
                            <mdb-select label="Dirección" placeholder="Dirección" [options]="optionsDireccion"
                              [filterEnabled]="true" formControlName="direccionDespacho"></mdb-select>
                            <div *ngIf="
                                                  formDatosDirecciones.get('direccionDespacho')
                                                    .invalid &&
                                                  (formDatosDirecciones.get('direccionDespacho')
                                                    .dirty ||
                                                    formDatosDirecciones.get(
                                                      'direccionDespacho'
                                                    ).touched)
                                                ">
                              <mdb-error *ngIf="
                                                    formDatosDirecciones.get(
                                                      'direccionDespacho'
                                                    ).errors.required
                                                  ">
                                La dirección de despacho es requerida
                              </mdb-error>
                            </div>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="md-form">
                            <input value="" type="text" id="localidad" class="form-control" placeholder="Localidad"
                              #localidad formControlName="localidad" />
                            <label for="localidad">Localidad</label>
                            <div *ngIf="
                                                  formDatosDirecciones.get('localidad')
                                                    .invalid &&
                                                  (formDatosDirecciones.get('localidad')
                                                    .dirty ||
                                                    formDatosDirecciones.get('localidad')
                                                      .touched)
                                                "></div>
                          </div>
                        </div>

                        <div class="col-6">
                          <div class="md-form">
                            <mdb-select label="Territorio" [options]="optionsTerritorioDireccion"
                              placeholder="Territorio" [filterEnabled]="true" formControlName="territorio"></mdb-select>
                            <div *ngIf="
                                                  formDatosDirecciones.get('territorio')
                                                    .invalid &&
                                                  (formDatosDirecciones.get('territorio')
                                                    .dirty ||
                                                    formDatosDirecciones.get('territorio')
                                                      .touched)
                                                ">
                              <mdb-error *ngIf="
                                                    formDatosDirecciones.get('territorio')
                                                      .errors.required
                                                  ">
                                El territorio es requerido
                              </mdb-error>
                            </div>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="md-form">
                            <mdb-select label="Ruta" [options]="optionsRutaDireccion" placeholder="Ruta"
                              [filterEnabled]="true" formControlName="ruta"></mdb-select>
                            <div *ngIf="
                                                  formDatosDirecciones.get('ruta').invalid &&
                                                  (formDatosDirecciones.get('ruta').dirty ||
                                                    formDatosDirecciones.get('ruta').touched)
                                                ">
                              <mdb-error *ngIf="
                                                    formDatosDirecciones.get('ruta').errors
                                                      .required
                                                  ">
                                La ruta es requerida
                              </mdb-error>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row mb-2" style="border-bottom: 1px solid #dee2e6">
                        <div class="col">
                          <h5 class="modal-title w-100 text-left" id="myModalLabel">
                            Datos de contacto
                          </h5>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          <div class="md-form">
                            <input value="" type="text" id="contacto" class="form-control" placeholder="Contacto"
                              #contacto formControlName="contacto" />
                            <label for="contacto">Contacto</label>

                          </div>
                        </div>
                        <div class="col-6">
                          <div class="md-form">
                            <input value="" type="text" id="fijo" class="form-control" placeholder="Fijo" #fijo
                              formControlName="fijo" />
                            <label for="fijo">Fijo</label>

                          </div>
                        </div>
                        <div class="col-6">
                          <div class="md-form">
                            <input value="" type="text" id="movil" class="form-control" placeholder="Movil" #movil
                              formControlName="movil" />
                            <label for="movil">Movil</label>

                          </div>
                        </div>
                        <div class="col-6">
                          <div class="md-form">
                            <input value="" type="email" id="email" class="form-control" placeholder="Email" #email
                              formControlName="email" />
                            <label for="email">Email</label>
                            <div *ngIf="
                                                  formDatosDirecciones.get('email').invalid &&
                                                  (formDatosDirecciones.get('email').dirty ||
                                                    formDatosDirecciones.get('email').touched)
                                                ">

                              <mdb-error *ngIf="
                                                    formDatosDirecciones.get('email').errors
                                                      .email
                                                  ">
                                El email es inválido
                              </mdb-error>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row" style="border-bottom: 1px solid #dee2e6">
                        <div class="col">
                          <h5 class="modal-title w-100 text-left" id="myModalLabel">
                            Referencias
                          </h5>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <!--Basic textarea-->
                          <div class="md-form">
                            <textarea type="text" id="form7" class="md-textarea form-control" placeholder="Escribe aquí"
                              mdbInput formControlName="referencias"></textarea>
                            <div *ngIf="
                                                  formDatosDirecciones.get('referencias')
                                                    .invalid &&
                                                  (formDatosDirecciones.get('referencias')
                                                    .dirty ||
                                                    formDatosDirecciones.get('referencias')
                                                      .touched)
                                                ">
                              <mdb-error *ngIf="
                                                    formDatosDirecciones.get('referencias')
                                                      .errors.maxlength
                                                  ">
                                Las referencias no pueden contener más de 2000
                                caracteres
                              </mdb-error>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row" style="border-bottom: 1px solid #dee2e6">
                        <div class="col">
                          <h5 class="modal-title w-100 text-left" id="myModalLabel">
                            Facturar a
                          </h5>
                        </div>
                      </div>

                      <div class="">
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" formControlName="facturarACasaMatriz"
                            id="inlineRadio1" [value]="RB_CASAMATRIZ_">
                          <label class="form-check-label" for="inlineRadio1">
                            Casa matríz
                          </label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" formControlName="facturarACasaMatriz"
                            id="inlineRadio2" [value]="RB_DIRECCION_ACT">
                          <label class="form-check-label" for="inlineRadio2">
                            Esta dirección
                          </label>
                        </div>
                      </div>

                      <div class="row" style="border-bottom: 1px solid #dee2e6">
                        <div class="col">
                          <h5 class="modal-title w-100 text-left" id="myModalLabel">
                            Agregar vendedor
                            <app-required-field></app-required-field>
                          </h5>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col">
                          <div class="md-form">
                            <mdb-select label="Vendedor" [options]="optionsVendedor" placeholder="Seleccionar vendedor"
                              [filterEnabled]="true" formControlName="VendedorSel"></mdb-select>
                          </div>
                        </div>
                        <!-- <div class="col">
                                            <div class="md-form">
                                              <mdb-select label="Rubro" [options]="optionsRubro" placeholder="Seleccionar Rubro"
                                                [filterEnabled]="true" formControlName="RubroSel"></mdb-select>
                                            </div>
                                          </div> -->
                        <div class="col">
                          <button mdbBtn type="button" color="info" mdbWavesEffect (click)="agregaVendedorRubro()">
                            Agregar
                          </button>
                        </div>
                      </div>


                    </div>
                  </div>



                  <div class="row" style="margin-top: 20px">
                    <div class="table-responsive">
                      <table class="
                          table table-striped table-hover table-sm
                          align-middle
                        ">
                        <thead class="grey lighten-2">
                          <tr>
                            <th colspan="3"></th>
                            <th colspan="7">IPT</th>
                            <th colspan="2"></th>
                          </tr>
                          <tr>
                            <th scope="col">Cod.</th>
                            <th scope="col">Vendedor</th>
                            <!-- <th scope="col">Rubro</th> -->
                            <th scope="col">L</th>
                            <th scope="col">M</th>
                            <th scope="col">Mi</th>
                            <th scope="col">J</th>
                            <th scope="col">V</th>
                            <th scope="col">S</th>
                            <th scope="col">D</th>
                            <th class="text-center">Cobranza</th>
                            <th scope="col">Rubros</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container *ngFor="let rubroipt of listaClienteVendedorRubroIPTFixed; let i = index">
                            <tr>
                              <td>{{ rubroipt.vendedor_codigo }}</td>
                              <td>{{ rubroipt.nombreVendedor }}</td>
                              <!-- <td>{{ rubroipt.nombreRubro }}</td> -->
                              <td>
                                <mdb-checkbox *ngIf="rubroipt.lunes" class="checkbox-teal" [checked]="true"
                                  (click)="CambiaIPT('lunes', rubroipt, i)"></mdb-checkbox>
                                <mdb-checkbox *ngIf="!rubroipt.lunes" class="checkbox-teal"
                                  (click)="CambiaIPT('lunes', rubroipt, i)"></mdb-checkbox>
                              </td>
                              <td>
                                <mdb-checkbox *ngIf="rubroipt.martes" [checked]="true" class="checkbox-teal"
                                  (click)="CambiaIPT('martes', rubroipt, i)"></mdb-checkbox>
                                <mdb-checkbox *ngIf="!rubroipt.martes" class="checkbox-teal"
                                  (click)="CambiaIPT('martes', rubroipt, i)"></mdb-checkbox>
                              </td>

                              <td>
                                <mdb-checkbox *ngIf="rubroipt.miercoles" [checked]="true" class="checkbox-teal" (click)="
                                  CambiaIPT('miercoles', rubroipt, i)
                                "></mdb-checkbox>

                                <mdb-checkbox *ngIf="!rubroipt.miercoles" class="checkbox-teal" (click)="
                                  CambiaIPT('miercoles', rubroipt, i)
                                "></mdb-checkbox>
                              </td>

                              <td>
                                <mdb-checkbox *ngIf="rubroipt.jueves" [checked]="true" class="checkbox-teal"
                                  (click)="CambiaIPT('jueves', rubroipt, i)"></mdb-checkbox>
                                <mdb-checkbox class="checkbox-teal" *ngIf="!rubroipt.jueves"
                                  (click)="CambiaIPT('jueves', rubroipt, i)"></mdb-checkbox>
                              </td>

                              <td>
                                <mdb-checkbox *ngIf="rubroipt.viernes" [checked]="true" class="checkbox-teal" (click)="
                                  CambiaIPT('viernes', rubroipt, i)
                                "></mdb-checkbox>
                                <mdb-checkbox *ngIf="!rubroipt.viernes" class="checkbox-teal" (click)="
                                  CambiaIPT('viernes', rubroipt, i)
                                "></mdb-checkbox>
                              </td>

                              <td>
                                <mdb-checkbox *ngIf="rubroipt.sabado" [checked]="true" class="checkbox-teal"
                                  (click)="CambiaIPT('sabado', rubroipt, i)"></mdb-checkbox>
                                <mdb-checkbox *ngIf="!rubroipt.sabado" class="checkbox-teal"
                                  (click)="CambiaIPT('sabado', rubroipt, i)"></mdb-checkbox>
                              </td>

                              <td>
                                <mdb-checkbox *ngIf="rubroipt.domingo" [checked]="true" class="checkbox-teal" (click)="
                                  CambiaIPT('domingo', rubroipt, i)
                                "></mdb-checkbox>
                                <mdb-checkbox *ngIf="!rubroipt.domingo" class="checkbox-teal" (click)="
                                  CambiaIPT('domingo', rubroipt, i)
                                "></mdb-checkbox>
                              </td>

                              <td class="text-center">
                                <div class="form-check">
                                  <input type="radio" class="form-check-input" [id]="rubroipt.vendedor_codigo"
                                    [checked]="rubroipt.es_cobrador" (change)="handleChangeCobrador(rubroipt)"
                                    mdbInput />
                                  <label class="form-check-label" [for]="rubroipt.vendedor_codigo"></label>
                                </div>
                              </td>
                              <td>
                                <button mdbBtn type="button" size="sm" color="primary" mdbWavesEffect
                                  class="btn-actions-sm" (click)="verRubros(rubroipt, i)">
                                  <mdb-icon fas icon="eye"></mdb-icon>
                                </button>
                              </td>
                              <td>
                                <button mdbBtn type="button" size="sm" color="primary" mdbWavesEffect
                                  class="btn-actions-sm" (click)="eliminaVendedorRubro(rubroipt)">
                                  <mdb-icon fas icon="trash"></mdb-icon>
                                </button>
                              </td>
                            </tr>
                            <ng-container *ngIf="rubroipt.rubrosVisibles">
                              <tr>
                                <td colspan="100%" style="text-align: center">
                                  <div
                                    style="white-space: break-spaces; display: flex; justify-content: flex-start; flex-wrap: wrap;">
                                    <ng-container *ngFor="let rubro of rubroipt.rubros">
                                      <div class="chip green lighten-2 white-text"
                                        style="position: unset; padding-right: 28px; cursor: default;">
                                        {{rubro.nombreRubro}}

                                      </div>
                                    </ng-container>
                                  </div>
                                </td>
                              </tr>
                            </ng-container>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </mdb-tab>

          <!--Panel 3: Datos Comerciales-->
          <mdb-tab heading="Datos comerciales">
            <div class="row">
              <div class="col-12">
                <app-clientes-form-datos-comerciales>
                </app-clientes-form-datos-comerciales>
              </div>
            </div>
          </mdb-tab>

          <!--Panel 4: Datos Financieros-->
          <mdb-tab heading="Datos financieros">
            <div class="row">
              <div class="col-12">
                <app-clientes-form-datos-financieros [optionsTipoCobro]="optionsTipoCobro"
                  [optionsCondicionPago]="optionsCondicionPago" [optionsListaPrecios]="optionsListaPrecios">
                </app-clientes-form-datos-financieros>
              </div>
            </div>
          </mdb-tab>
        </mdb-tabset>
      </div>

      <div class="modal-footer justify-content-between">
        <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
          (click)="datosEditarProveedor.hide()" mdbWavesEffect>
          Cerrar
        </button>

        <button *ngIf="EnableNext === 1" size="sm" type="button" class="btn btn-sm btn-secondary waves-light"
          mdbWavesEffect (click)="NextTab(1)">
          Siguiente
        </button>

        <button *ngIf="EnableNext === 2" size="sm" type="button" class="btn btn-sm btn-secondary waves-light"
          mdbWavesEffect (click)="NextTab(2)">
          Siguiente
        </button>

        <button *ngIf="EnableNext === 3" size="sm" type="button" class="btn btn-sm btn-secondary waves-light"
          mdbWavesEffect (click)="NextTab(3)">
          Siguiente
        </button>

        <button *ngIf="EnableNext === 4" size="sm" type="button" class="btn btn-sm btn-secondary waves-light"
          mdbWavesEffect (click)="validarYAgregar()">
          Guardar
        </button>
      </div>
    </div>
  </div>
</div>